module.exports = __webpack_public_path__ + "static/media/acerta-provider.dfe4e8af.svg";